import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Battle ended" notification. Subject is the battle's discussion.
 * content: { reason, winnerId, winnerName }
 */
export default class BattleEndedNotification extends Notification {
  icon() {
    return 'fas fa-trophy';
  }
  href() {
    const discussion = this.attrs.notification.subject();
    return discussion ? app.route.discussion(discussion) : '#';
  }
  content() {
    const content = this.attrs.notification.content() || {};
    if (content.winnerName) {
      return app.translator.trans('forumaker-arena.forum.notifications.battle_ended_winner_text', {
        winner: m("strong", null, content.winnerName)
      });
    }
    return app.translator.trans('forumaker-arena.forum.notifications.battle_ended_text');
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/BattleEndedNotification', BattleEndedNotification);